import { useMutation, useQuery } from '@tanstack/react-query';
import accountsService from '../services/accountsService';

export const useDeleteMultipleAccounts = () => {
	return useMutation({
		mutationKey: ['accounts'],
		mutationFn: (data: DeleteMultipleAccountsRequest[]) =>
			accountsService.deleteMultipleAccounts(data),
	});
};

export const useGetSingleAccount = (accountID: number) => {
	return useQuery<Account>({
		queryKey: ['account', accountID],
		queryFn: () =>
			accountsService.getSingleResource(accountID, {
				getRelated: 'users,userAccounts',
			}),
	});
};

export const useGetAllAccounts = (options?: {
	filters?: string;
	isEnabled?: boolean;
}) => {
	return useQuery<TavoittajaApiResponse<{ accounts: Account[] }>>({
		queryKey: ['accounts'],
		queryFn: () =>
			accountsService.getAllResources({
				filters: options?.filters,
			}),
		enabled: options?.isEnabled === false ? false : true,
	});
};

export const useDeleteAccount = () => {
	return useMutation({
		mutationKey: ['accounts'],
		mutationFn: (id: number) => accountsService.deleteSingleResource(id),
	});
};

export const useUpdateAccount = () => {
	return useMutation({
		mutationKey: ['accountUpdate'],
		mutationFn: (data: Partial<UpdateAccountRequest>) =>
			accountsService.update(data),
	});
};

export const useAddCredits = () => {
	return useMutation({
		mutationKey: ['addCredits'],
		mutationFn: (data: { accountID: number; creditCount: number }) =>
			accountsService.addCredits(data),
	});
};

export const useRemoveCredits = () => {
	return useMutation({
		mutationKey: ['removeCredits'],
		mutationFn: (data: { accountID: number; creditCount: number }) =>
			accountsService.removeCredits(data),
	});
};
